export enum CertificateAlignment {
	Left = 'L',
	Center = 'C',
	Right = 'R',
}